import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import { Flex, Input } from "@100mslive/roomkit-react";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import { SESSION_AUTH } from "../../../common/auth";
import { USER_SERVICES } from "../../../services";

const ProfileUsernamePopup = props => {
  const { onClose, onUpdate, username } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [newusername, setNewUsername] = useState(username);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isUserSession && isUserSession?.isVerify) {
      setUserData(isUserSession);
    } else {
      setUserData("");
      onClose();
      return;
    }
    return () => null;
  }, [isUserSession, onClose]);

  const onSave = async () => {
    if (!newusername) {
      return ToastManager.addToast({ title: "Enter username" });
    } else if (!/^[a-zA-Z0-9_-]{3,30}$/.test(newusername)) {
      return ToastManager.addToast({
        title: "Invalid username! ",
      });
    } else {
      setLoading(true);

      try {
        USER_SERVICES.updateUsername({
          userId: userData.userId,
          org: userData?.org?.id,
          username: newusername,
        })
          .then(data => {
            if (data.code === 200) {
              onUpdate(newusername);
              ToastManager.addToast({ title: data.message });
            } else if (data.code === 600) {
              onClose();
              LOGOUT_USER_SESSION();
            } else {
              ToastManager.addToast({ title: data.message });
            }
          })
          .catch(err => {
            ToastManager.addToast({
              title: err?.message,
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (e) {
        ToastManager.addToast({ title: "An error has occured" });
      }
    }
  };
  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog"
      fullWidth
      maxWidth="sm"
    >
      {loading && <FullPageProgress fixed={true} />}
      <DialogTitle className="text-center">Change your username </DialogTitle>
      <DialogContent>
        <div className="mt-20 custom-form">
          <FormControl className="custom-form-group">
            <label
              htmlFor="changeusername"
              className="custom-form-label big-label"
              style={{ display: "flex" }}
            >
              Username <span className="ml-auto">{newusername?.length}/30</span>
            </label>
            <Input
              id="changeusername"
              className="custom-form-input"
              value={newusername}
              type="text"
              onChange={e => {
                if (
                  e.target?.value?.length <= 30 &&
                  /^[a-zA-Z0-9_-]{0,30}$/.test(e.target?.value)
                )
                  setNewUsername(
                    e.target?.value?.toLowerCase()?.trim().slice(0, 30)
                  );
              }}
              maxLength={30}
            />

            <div className="userLogin-email-text mb-20 mt-15">
              * Username must be 3–30 characters.
              <br />* Only letters, numbers, underscores (_) or hyphens (-).
            </div>
          </FormControl>

          <Flex className="mt-0 mb-20" />
        </div>
      </DialogContent>
      <DialogActions className="custom-dialog-action">
        {username !== newusername ? (
          <Button
            onClick={onSave}
            variant="outlined"
            color="primary"
            className="events6ix-btn events6ix-btn-primary"
            type="button"
          >
            Save
          </Button>
        ) : null}
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          className="events6ix-btn events6ix-btn-light"
          type="button"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileUsernamePopup;
